import { TelemetryErrorTagEnum } from '../enums';
import { ITelemetryErrorCode } from '../interfaces';

export const GUEST_CHECKIN_GROUP = 'GUEST_CHECK_IN';

export const unknownErrorCode: ITelemetryErrorCode = {
  lookup: 'GC-000-UNKNOWN',
  code: 'GC-000',
  tag: TelemetryErrorTagEnum.UNKNOWN,
  group: GUEST_CHECKIN_GROUP,
  label: 'UNKNOWN',
};

const reservationSession: ITelemetryErrorCode = {
  code: 'GC-001',
  group: GUEST_CHECKIN_GROUP,
  label: 'POST RESERVATION FAILED',
  lookup: 'GC-001-POST-RESERVATION-FAILED',
  tag: TelemetryErrorTagEnum.ENDPOINT,
};
export const errorCodesList: ITelemetryErrorCode[] = [
  unknownErrorCode,
  {
    ...reservationSession
  },
  {
    code: 'GC-002',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET SESSION EXTENDED FAILED',
    lookup: 'GC-002-GET-SESSION-EXTENDED-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-003',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET SESSION END FAILED',
    lookup: 'GC-003-GET-SESSION-END-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-004',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST LIFECYCLE END FAILED',
    lookup: 'GC-004-POST-LIFECYCLE-END-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-005',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET PERSONAL DETAIL CONTENT FAILED',
    lookup: 'GC-005-GET-PERSONAL-DETAIL-CONTENT-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-006',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET SECURITY PHOTO LIST FAILED',
    lookup: 'GC-006-GET-SECURITY-PHOTO-LIST-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-007',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET SAILING INFORMATION ENRICHED FAILED',
    lookup: 'GC-007-GET-SAILING-INFORMATION-ENRICHED-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-008',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET PROFILE BOOKINGS FAILED',
    lookup: 'GC-008-GET-PROFILE-BOOKINGS-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-009',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET SELECTED GUEST DETAILS FAILED',
    lookup: 'GC-009-GET-SELECTED-GUEST-DETAILS-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-010',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET TRAVEL QUESTIONAIRE FAILED',
    lookup: 'GC-010-POST-TRAVEL-QUESTIONNAIRE-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-011',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST GUEST STATUSES FAILED',
    lookup: 'GC-011-POST-GUEST-STATUSES-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-012',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST AUTHORIZED CONSENTS FAILED',
    lookup: 'GC-012-POST-AUTHORIZED-CONSENTS_FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-013',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET VALID TRAVEL DOCUMENTS LIST FAILED',
    lookup: 'GC-013-GET-VALID-TRAVEL-DOCUMENTS-LIST-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-014',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET CRUISE CONTRACT FAILED',
    lookup: 'GC-014-GET-CRUISE-CONTRACT-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-015',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST TO VALIDATE LOYALTY NUMBER FAILED',
    lookup: 'GC-015-POST-VALIDATE-LOYALTY-NUMBER-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-016',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST TO SAVE SECURITY PHOTO FAILED',
    lookup: 'GC-016-POST-SAVE-SECURITY-PHOTO-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-017',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST TO UPDATE SECURITY PHOTO FAILED',
    lookup: 'GC-017-POST-UPDATE-SECURITY-PHOTO-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-018',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST TO DELETE SECURITY PHOTO FAILED',
    lookup: 'GC-018-POST-DELETE-SECURITY-PHOTO-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-019',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST TO SAVE PERSONAL DETAILS FAILED',
    lookup: 'GC-019-POST-SAVE-PERSONAL-DETAILS-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-020',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST TO GET TRAVEL QUESTIONNAIRE FAILED',
    lookup: 'GC-020-POST-GET-TRAVEL-QUESTIONNAIRE-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-021',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET GOVERNANCE CONTENT FAILED',
    lookup: 'GC-021-GET-GOVERNANCE-CONTENT-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-022',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET RESOURCE BUNDLE FAILED',
    lookup: 'GC-022-GET-RESOURCE-BUNDLE-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-023',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET CRUISE CONTRACT EMAIL FAILED',
    lookup: 'GC-023-GET-CRUISE-CONTRACT-EMAIL-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-024',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST-CRUISE-CONTRACT-AUTHORIZATIONS-FAILED',
    lookup: 'GC-024-POST-CRUISE-CONTRACT-AUTHORIZATIONS-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-025',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET ONBOARD EXPENSES FAILED',
    lookup: 'GC-025-POST-ONBOARD-PAYMENT-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-026',
    group: GUEST_CHECKIN_GROUP,
    label: 'CREATE UPDATE ONBOARD PAYMENT FAILED',
    lookup: 'GC-026-POST-CREATE-UPDATE-ONBOARD-PAYMENT-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-027',
    group: GUEST_CHECKIN_GROUP,
    label: 'CREATE UPDATE ONBOARD PAYMENT FAILED',
    lookup: 'GC-027-POST-BOARDING-PASS-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-028',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET ARRIVAL APPOINTMENT FAILED',
    lookup: 'GC-028-GET-ARRIVAL-APPOINTMENT-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-029',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST ARRIVAL APPOINTMENT FAILED',
    lookup: 'GC-029-POST-ARRIVAL-APPOINTMENT-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-030',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST AUTHORIZED CONSENTS FAILED',
    lookup: 'GC-030-POST-AUTHORIZED-CONSENTS-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-031',
    group: GUEST_CHECKIN_GROUP,
    label: 'SET OR UPDATE ARRIVAL TIME FAILED',
    lookup: 'GC-031-SET-OR-UPDATE-ARRIVAL-TIME-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-032',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET CREDIT CARD COUNTRY FAILED',
    lookup: 'GC-032-GET-CREDIT-CARD-COUNTRY-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-033',
    group: GUEST_CHECKIN_GROUP,
    label: 'CHECKIN CURRENTLY NOT AVAILABLE ERROR PAGE',
    lookup: 'GC-033-CHECKIN-CURRENTLY-NOT-AVAILABLE-ERROR-PAGE',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-034',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST GUEST INFORMATION FAILED',
    lookup: 'GC-034-POST-GUEST-INFORMATION-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-035',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST RETRIEVE VALID TRAVEL DOCUMENTS',
    lookup: 'GC-035-POST-RETRIEVE-VALID-TRAVEL-DOCUMENTS',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-036',
    group: GUEST_CHECKIN_GROUP,
    label: 'SAVE PASSENGER SURVEY FAILED',
    lookup: 'GC-036-SAVE-PASSENGER-SURVEY-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-037',
    group: GUEST_CHECKIN_GROUP,
    label: 'GET COUNTRIES FAILED',
    lookup: 'GC-037-GET-COUNTRIES-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-038',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST RETRIEVE CRUISE SURVEY FAILED',
    lookup: 'GC-038-POST-RETRIEVE-CRUISE-SURVEY-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'GC-039',
    group: GUEST_CHECKIN_GROUP,
    label: 'POST SAVE CRUISE SURVEY FAILED',
    lookup: 'GC-039-POST-SAVE-CRUISE-SURVEY-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
];